import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MoonIcon from '../MoonIcon/MoonIcon';
import { getSkyToday } from '../../services/skyService';
import './MoonBadge.css';

const HIDDEN_PREFIXES = ['/moon-phase-today', '/home', '/account', '/support', '/wallet', '/llm', '/translate', '/ban-ip', '/stream-ban'];

const MoonBadge = () => {
  const { pathname } = useLocation();
  const [sky, setSky] = useState(null);
  const hidden = HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix));

  useEffect(() => {
    if (hidden || sky) return undefined;
    let live = true;
    getSkyToday().then((data) => live && setSky(data)).catch(() => {});
    return () => {
      live = false;
    };
  }, [hidden, sky]);

  if (hidden || !sky) return null;
  const percent = Math.round(sky.illumination * 100);
  return (
    <a
      className="moon-badge"
      href="/moon-phase-today/"
      title={`${sky.phase} in ${sky.moon_sign}, ${percent}% lit. See what tonight's moon means.`}
    >
      <MoonIcon angle={sky.angle} size={30} />
      <span className="moon-badge-text">
        <strong>{sky.phase}</strong>
        <span>{percent}% · Moon in {sky.moon_sign}</span>
      </span>
    </a>
  );
};

export default MoonBadge;
